export default __webpack_public_path__ + "static/media/order_priority_red.a140b100.svg";